module.exports = __webpack_public_path__ + "img/distance-indigo.04ef3f54.svg";